import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
import { FilterMatchMode, FilterOperator } from "primereact/api";
const CustomDataTableEditable = ({
  data = [],
  buttons = [],
  columns = [
    {
      header: "",
      field: "",
      body: (rowData) => null,
      sortable: false,
      filter: false,
      editorOption: "text",
      dropdownOptions: [],
    },
  ],
  onRowEditComplete = function() {},
}) => {
  const [filters, setFilters] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const dt = useRef(null);
  const [editingRows, setEditingRows] = useState({});

  useEffect(() => {
    initFilters();
  }, []);

  const clearFilter = () => {
    initFilters();
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  const initFilters = () => {
    const filtersTmp = { ...filters };
    filtersTmp["global"] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    if (typeof columns !== "undefined") {
      columns.map((column, index) => {
        if (column.filter === true) {
          filtersTmp[`${column.field}`] = {
            operator: FilterOperator.AND,
            constraints: [
              { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            ],
          };
        }
      });
    }
    setFilters(filtersTmp);
    setGlobalFilter("");
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
      />
    );
  };

  const dropdownEditor = (options, dropdownOptions) => {
    return (
      <Dropdown
        value={options.value}
        options={dropdownOptions}
        optionLabel="label"
        optionValue="value"
        filter
        showClear
        filterBy="label"
        onChange={(e) => options.editorCallback(e.value)}
      />
    );
  };

  const priceEditor = (options) => {
    return (
      <InputNumber
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
        mode="currency"
        currency="IDR"
        //locale="en-ID"
      />
    );
  };

  const header = (
    <div className="table-header">
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <span className="text-nowrap">
            <span className="text-nowrap">
              {buttons.length > 0 ? (
                <React.Fragment>
                  {buttons.map((button, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`btn btn-${
                        button.color ? button.color : "primary"
                      } btn-sm btn-pill btn-bold mx-1 my-1`}
                      variant="primary"
                      onClick={button.onClick}
                    >
                      {button.icon ? <i className={button.icon}></i> : null}
                      {button.name}
                    </button>
                  ))}
                </React.Fragment>
              ) : null}
            </span>
            <BootstrapTooltip title="Edit All">
              <button
                type="button"
                onClick={() => {}}
                className="btn btn-icon btn-label-primary btn-circle btn-sm mx-1 my-1"
              >
                <i className="fas fa-pen"></i>
              </button>
            </BootstrapTooltip>
            <BootstrapTooltip title="Commit All Changes">
              <button
                type="button"
                onClick={() => {}}
                className="btn btn-icon btn-label-success btn-circle btn-sm mx-1 my-1"
              >
                <i className="fas fa-check"></i>
              </button>
            </BootstrapTooltip>
            <BootstrapTooltip title="Cancel All Changes">
              <button
                type="button"
                onClick={() => {}}
                className="btn btn-icon btn-label-danger btn-circle btn-sm mx-1 my-1"
              >
                <i className="fas fa-times"></i>
              </button>
            </BootstrapTooltip>
          </span>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <span className="p-input-icon-left float-md-right mx-1 my-1">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={globalFilter}
              onChange={onGlobalFilterChange}
              placeholder="Global Search"
            />
          </span>
          <BootstrapTooltip title="Refresh Filter Criteria">
            <button
              type="button"
              className="btn btn-label-brand btn-sm btn-pill btn-bold float-md-right mx-1 my-1"
              onClick={() => {
                setGlobalFilter("");
                dt.current.reset();
                clearFilter();
              }}
            >
              <i className="pi pi-filter-slash"></i>
              Clear
            </button>
          </BootstrapTooltip>
        </div>
      </div>
    </div>
  );
  return (
    <React.Fragment>
      <div className="card datatable-responsive datatable-filter">
        <DataTable
          header={header}
          globalFilter={globalFilter}
          filters={filters}
          filterDisplay="menu"
          responsiveLayout="scroll"
          value={data}
          editMode="row"
          onRowEditComplete={(e) => onRowEditComplete(e)}
          ref={dt}
          stripedRows
          size="small"
          emptyMessage="You have no data at this time"
        >
          {columns.map((column, index) => (
            <Column
              key={index}
              header={column.header}
              field={column.field}
              body={column.body}
              sortable={column.sortable}
              filter={column.filter}
              style={{
                whiteSpace: "nowrap",
              }}
              filterPlaceholder={`🔍 ${column.header}`}
              editor={(options) => {
                if (column.editorOption === "text") {
                  return textEditor(options);
                } else if (column.editorOption === "dropdown") {
                  return dropdownEditor(options, column.dropdownOptions);
                } else if (column.editorOption === "currency") {
                  return priceEditor(options);
                }
              }}
            />
          ))}
          <Column
            rowEditor
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>
    </React.Fragment>
  );
};

export default CustomDataTableEditable;
